<div data-testid="o2o-audit-page" class="p-4 flex-table-page">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "o2o.audit.title" | translate }}
  </h2>
  <!-- Search Form -->
  <app-search-form
    data-testid="o2o-audit-search-form"
    [orderSources]="orderSources()"
    [salesChannels]="salesChannels()"
    [buyerNotesOptions]="buyerNotesOptions()"
    [giftOptions]="giftOptions()"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions">
      <app-status-filter
        [primaryButton]="primaryButton"
        [secondaryButton]="secondaryButton"
        (primaryButtonClick)="onApprove()"
        (secondaryButtonClick)="onReject()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Status Filter with Action Buttons -->
  <div class="mb-2 flex-table-header">
    <app-status-filter
      [statusOptions]="statusOptions"
      (statusChange)="onStatusChange($event)"
    ></app-status-filter>
  </div>

  <!-- Data Table -->

  <div class="flex-table-section">
    <app-data-table
      data-testid="o2o-audit-table"
      [dataSource]="orders()"
      [columns]="tableColumns"
      [rows]="pageSize()"
      [first]="first()"
      [totalRecords]="totalRecords()"
      scrollHeight="flex"
      [loading]="loading()"
      [selection]="selectedOrders()"
      [hasCheckColumn]="true"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
    ></app-data-table>
  </div>

  <!-- Reject Dialog -->
  <!-- <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" 
       *ngIf="showRejectDialog()">
    <div class="bg-white rounded-lg p-6 w-96 max-w-md">
      <h3 class="text-lg font-semibold mb-4">Reject Orders</h3>
      <div class="space-y-4">
        <p class="text-gray-600">
          Are you sure you want to reject the selected {{ selectedOrders().length }} order(s)?
        </p>
        <div class="form-field">
          <label class="form-label text-sm font-medium text-gray-700">Rejection Reason</label>
          <textarea
            [ngModel]="rejectReason()"
            (ngModelChange)="rejectReason.set($event)"
            rows="4"
            class="w-full text-sm border border-gray-300 rounded-md px-3 py-2"
            placeholder="Please provide a reason for rejection..."
          ></textarea>
        </div>
      </div>
      <div class="flex justify-end gap-2 mt-6">
        <button
          type="button"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          (click)="cancelReject()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
          [disabled]="!rejectReason()"
          (click)="confirmReject()"
        >
          Confirm Reject
        </button>
      </div>
    </div>
  </div> -->
</div>
